import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid py-3" }
const _hoisted_2 = {
  key: 0,
  class: "p-2"
}
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = {
  key: 1,
  class: "p-2"
}
const _hoisted_5 = {
  key: 2,
  class: "col p-2"
}
const _hoisted_6 = { class: "col text-right" }
const _hoisted_7 = {
  key: 0,
  class: "overflow-y-auto scrollbar flex-1 px-0"
}
const _hoisted_8 = {
  key: 1,
  class: "bg-white p-3 my-3 border-round-sm text-sm mt-5"
}

import { onMounted, ref, watch, onUnmounted, onBeforeUnmount, computed } from 'vue';
import { storeToRefs } from 'pinia';
import VirtualScroller from 'primevue/virtualscroller';
import ActivityLogItem from '@/components/ActivityLog/ActivityLogItem.vue';
import { useActivityLogStoreDashboard, useAuthStore, useOrganizationStore } from '@/store';
import { can, useDateTime, useRequestCancel, useRouting } from '@/composables';
import { ACTIVITY_EVENT_TYPE, PERMISSIONS, REQUEST } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityLog',
  setup(__props) {

const dateUtils = useDateTime();
const activityLogDashboardStore = useActivityLogStoreDashboard();
const authStore = useAuthStore();
const organizationStore = useOrganizationStore();
const { organizationsIdsSelected } = storeToRefs(organizationStore);
const filterTypeSelected = ref('');
const dates = ref<Date[] | null>([]);
const { logs, loading } = storeToRefs(activityLogDashboardStore);
const $routing = useRouting();
const searchFilter = ref();
const filtersType = ref([
  {
    name: 'All Activity',
    event_type: '',
  },
  {
    name: 'Import Activity',
    event_type: ACTIVITY_EVENT_TYPE.IMPORT,
  },
  { name: 'RSM', event_type: ACTIVITY_EVENT_TYPE.RSM_FILE_PROCESSED, visible: authStore.currentInstanceIsMasterTenant },
]);

watch(
  () => organizationsIdsSelected.value,
  async () => {
    await activityLogDashboardStore.getLogs(organizationsIdsSelected.value);
  },
);

onMounted(async () => {
  activityLogDashboardStore.restorePaginationState(true);
  defineDefaultDates();
  await init();
});

const organizationAssociated: number[] = computed(() =>
  authStore.organizationAssociated.map((organization) => organization.key),
);

const init = async () => {
  defineDateQueryParams();

  if (organizationsIdsSelected.value.length > 0) {
    await activityLogDashboardStore.getLogs(organizationsIdsSelected.value);
  } else {
    const organizationIdToSee = !can([PERMISSIONS.DASHBOARD_ACTIVITY_INDEX_ALL]) ? organizationAssociated?.value : [];
    await activityLogDashboardStore.getLogs(organizationIdToSee || []);
  }
};

const defineDefaultDates = () => {
  const end = new Date();
  const start = new Date(end.getTime() - 28 * 24 * 60 * 60 * 1000);
  const defaultDates: Date[] = [start, end];

  dates.value = defaultDates;
  activityLogDashboardStore.filters.start_at = dateUtils.formatDateForApi(start);
  activityLogDashboardStore.filters.end_at = dateUtils.formatDateForApi(end);
};

const defineDateQueryParams = () => {
  if (dates.value && dates.value.length > 1) {
    activityLogDashboardStore.filters.start_at = dateUtils.formatDateForApi(dates.value[0]);
    activityLogDashboardStore.filters.end_at = dateUtils.formatDateForApi(dates.value[1]);

    $routing.addQueryParams({
      start_at: activityLogDashboardStore.filters.start_at,
      end_at: activityLogDashboardStore.filters.end_at,
    });
  }
};

const onDateRangeChange = async (event: Date[]) => {
  dates.value = event;
  defineDateQueryParams();
  await init();
};

const onSearch = async (search: string) => {
  const hasSearchTerm = search.length >= 3;

  if (hasSearchTerm) {
    activityLogDashboardStore.filters.search = search;
    await init();
  }
};

const onSearchByEvent = async () => {
  activityLogDashboardStore.logs = [];
  activityLogDashboardStore.filters.event_type = filterTypeSelected.value !== '' ? filterTypeSelected.value : '';
  activityLogDashboardStore.loading = false;
  activityLogDashboardStore.currentPage = 0;
  await init();
};

onBeforeUnmount(() => useRequestCancel().requestSaverAbort(REQUEST.LOGS));

onUnmounted(() => activityLogDashboardStore.$reset());

const onLazyLoadLogs = async (event) => {
  const difference = event.last - event.first;

  if (difference >= 30 && difference <= 35) {
    const organizationIdToSee = !can([PERMISSIONS.DASHBOARD_ACTIVITY_INDEX_ALL]) ? organizationAssociated?.value : [];
    await activityLogDashboardStore.getLogs(organizationIdToSee || []);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_AppDateRangePicker = _resolveComponent("AppDateRangePicker")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(can)([_unref(PERMISSIONS).DASHBOARD_ACTIVITY_DATE_VIEW]))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_AppDateRangePicker, {
                  modelValue: dates.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dates).value = $event)),
                  value: dates.value,
                  onChange: onDateRangeChange
                }, null, 8, ["modelValue", "value"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(can)([_unref(PERMISSIONS).DASHBOARD_ACTIVITY_FILTER_EVENT_TYPE_VIEW]))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_Dropdown, {
                id: "type_log",
                modelValue: filterTypeSelected.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterTypeSelected).value = $event)),
                options: filtersType.value,
                "option-label": "name",
                "option-value": "event_type",
                placeholder: "All Activity",
                onChange: onSearchByEvent
              }, null, 8, ["modelValue", "options"])
            ]))
          : _createCommentVNode("", true),
        (_unref(can)([_unref(PERMISSIONS).DASHBOARD_ACTIVITY_DATE_SEARCH]))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_IconField, { "icon-position": "left" }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputIcon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        name: "search",
                        class: "text-lg"
                      })
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_component_InputText, {
                    modelValue: searchFilter.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchFilter).value = $event)),
                    class: "w-full pl-5",
                    placeholder: "Search",
                    "min-length": 3
                  }, null, 8, ["modelValue"]), [
                    [_directive_debounce, onSearch, "600ms"]
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_unref(loading))
            ? (_openBlock(), _createBlock(_component_Spinner, {
                key: 0,
                size: 25
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      (_unref(logs).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_unref(VirtualScroller), {
              items: _unref(logs),
              "item-size": 50,
              lazy: true,
              "scroll-height": "550px",
              onLazyLoad: onLazyLoadLogs
            }, {
              item: _withCtx(({ item }) => [
                (_openBlock(), _createBlock(ActivityLogItem, {
                  key: item.id,
                  "access-tenant": item.access_tenant,
                  subject: item.subject,
                  description: item.description,
                  "subject-type": item.subject_type,
                  causer: item.causer,
                  "impersonated-by": item.impersonated_by,
                  event: item.event,
                  properties: item.properties,
                  custom: item.custom,
                  "time-ago": item.updated_at,
                  changes: item.changes
                }, null, 8, ["access-tenant", "subject", "description", "subject-type", "causer", "impersonated-by", "event", "properties", "custom", "time-ago", "changes"]))
              ]),
              _: 1
            }, 8, ["items"])
          ]))
        : _createCommentVNode("", true),
      (!_unref(loading) && !_unref(logs).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("p", { class: "text-center" }, "No activity was found.", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})